/** Display labels for J-code denial-risk issues (tooltips, gradient badge). */
export enum JCodeIssueLabel {
  NON_PREFERRED_DRUGS = "Non Preferred Drugs",
  NCCN_GUIDELINES_NOT_MET = "Not Following NCCN guidelines",
  NCCN_GUIDELINES_MET = "NCCN Guidelines met",
  MISSING_DX_CODE = "No valid ICD code found",
  CONTINUATION = "Continuation of Care",
  MULTIPLE_DENIAL_RISKS = "Multiple Denial risks",
  NO_DENIAL_RISKS_FOUND = "No denial risks found",
  INITIATION = "Initial Line",
}

/** Backend/API status values used in the J-code denial flow (drug preference, NCCN match, initiation/continuation). */
export enum JCodeStatusValue {
  /** Value for drug_preference when drug is non-preferred */
  NON_PREFERRED = "non_preferred",
  /** Value for nccn_match / regimen_icd_state when no match (e.g. missing Dx, NCCN not met) */
  NO_MATCH = "no_match",
  /** Value for initiation_continuation_status when continuation */
  CONTINUATION = "continuation",
}
